import locations from './locations';
import offers from './offers';
import orders from './orders';
import user from './user';

export const reducers = {
  user,
  locations,
  offers,
  orders,
};
